import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getNearsightedTrackListReportList } from 'models/nearsightedTrackMedicineReport';
import { getNearsightedTrackListReportList as getNearsightedTrackOrthoReportList } from 'models/nearsightedTrackReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

// import InpatientListInner from './Inner';

const routes: CustomRoute = {
	path: '/nearsighted-track-medicine',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inpatientList' */ './component')],
			render: ([NearsightedTrackMedicine]) => <NearsightedTrackMedicine />,
			onEnter: async ({ store, next }) => {
				console.log('on Nearsighted Track Medicine Page');
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.NEARSIGHTED_TRACK_MEDICINE}`);
				if (allowEnter) {
					await store.dispatch(getNearsightedTrackListReportList());
					await store.dispatch(getNearsightedTrackOrthoReportList());
				}
				const children = await next();
				return children;
			},
		},
		// InpatientListInner,
	],
};
export default routes;
